export default __webpack_public_path__ + "static/media/organization-icon.90edb6b1.svg";